export const COLLAPSED_ORG_SELECTOR_WIDTH = 56;
export const DEFAULT_ORG_SELECTOR_EXPANDED_WIDTH = 200;
export const MIN_ORG_SELECTOR_EXPAND_WIDTH =
	COLLAPSED_ORG_SELECTOR_WIDTH +
	(DEFAULT_ORG_SELECTOR_EXPANDED_WIDTH - COLLAPSED_ORG_SELECTOR_WIDTH) / 2;
export const MAX_ORG_SELECTOR_EXPANDED_WIDTH = 400;
export const ORG_SELECTOR_WIDTH_LS_KEY = 'AS_ORG_SELECTOR_WIDTH';
export const ASSETS_APP_KEY = 'ASSETS';
export const TENANTLESS_ORG_ID = 'tenantless';
